import React from 'react';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export interface IAggregationParms {
  className?: string
}

const useStyles: () => Record<string, string> = makeStyles((theme: Theme) => ({

  boundingRect: {
    fill: '#d9f1fd',
    stroke: '#204284',
    strokeMiterLimit: '10',
    strokeWidth: '20px',
  },

  circle: {
    fill: '#d9f1fd',
    strokeWidth: '10px',
  },

  arrow: {
    fill: '#129cd8',
    stroke: '#204284',
    strokeMiterLimit: '10',
    strokeWidth: '10px',

  },

  square: {
    fill: '#129cd8',
    stroke: '#204284',
    strokeMiterLimit: '10',
    strokeWidth: '10px',
  },

  triangle: {
    fill: '#7b489c',
    strokeWidth: '10px',
    stroke: '#204284',
    strokeMiterLimit: '10',
  },


}));


// By wrapping this component's definition in React.forwardRef, we enable having the ability to accept a React.Ref (ref?) parameter, in addition to the 
// normal 'props' parameter collection. The 'ref' allows us to forward the embedded <svg> element as a DOM reference
const Aggregation = React.forwardRef((props: IAggregationParms, ref?: React.Ref<SVGSVGElement>) => {

  const { className } = props;
  const classes: Record<string, string> = useStyles();

  return (
    <svg ref={ref} className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 520 520" >
      <defs>
      </defs>
      <g id="AggregationIcon">

        <rect id="BorderAndBackground" className={classes.boundingRect} x="10" y="10" width="500" height="500" rx="10.44" ry="10.44" />

        <g id="AggregatedFigures">
          <rect id="Square" className={classes.square} x="188.57" y="188.57" width="142.86" height="142.86" rx="20" ry="20" />
          <circle id="Circle" className={classes.circle} cx="260" cy="260" r="64.29" />
          <path id="Triangle" className={classes.triangle} d="M299.78,294.01l-79.64-.51c-7.7-.05-12.46-8.41-8.56-15.06l40.27-68.72c3.89-6.64,13.51-6.58,17.32.11l39.38,69.23c3.81,6.69-1.06,14.99-8.76,14.94Z" />
        </g>
        <g id="Arrows">
          <g id="TopRightArrow">
            <path className={classes.arrow} d="M339.9,192.04c14.74,17.33,29.71,27.63,51.38,34.29l-3.29-22.46c50.84-22.79,80.26-65.21,80.88-121.17-2.8-.16-4.21-.24-7.01-.4-8.26,44.58-34.94,75.7-78.72,88.47-1.32-8.98-1.98-13.47-3.29-22.46-10.79,16.92-24.71,30.8-39.94,43.72Z" />
          </g>
          <g id="TopLeftArrow">
            <path className={classes.arrow} d="M180.05,192.04c-14.74,17.33-29.71,27.63-51.38,34.29l3.29-22.46c-50.84-22.79-80.26-65.21-80.88-121.17,2.8-.16,4.21-.24,7.01-.4,8.26,44.58,34.94,75.7,78.72,88.47,1.32-8.98,1.98-13.47,3.29-22.46,10.79,16.92,24.71,30.8,39.94,43.72Z" />
          </g>
          <g id="BottomRightArrow">
            <path className={classes.arrow} d="M339.9,327.96c14.74-17.33,29.71-27.63,51.38-34.29l-3.29,22.46c50.84,22.79,80.26,65.21,80.88,121.17-2.8.16-4.21.24-7.01.4-8.26-44.58-34.94-75.7-78.72-88.47-1.32,8.98-1.98,13.47-3.29,22.46-10.79-16.92-24.71-30.8-39.94-43.72Z" />
          </g>
          <g id="BottomLeftArrow">
            <path className={classes.arrow} d="M180.05,327.96c-14.74-17.33-29.71-27.63-51.38-34.29,1.32,8.98,1.98,13.47,3.29,22.46-50.84,22.79-80.26,65.21-80.88,121.17,2.8.16,4.21.24,7.01.4,8.26-44.58,34.94-75.7,78.72-88.47,1.32,8.98,1.98,13.47,3.29,22.46,10.79-16.92,24.71-30.8,39.94-43.72Z" />
          </g>
        </g>

      </g>

    </svg >
  )
});

export default Aggregation;
